/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import * as t from "io-ts";

// required attributes
const CacheR = t.interface({});

// optional attributes
const CacheO = t.partial({
  id: t.string,

  time: t.string,

  version: t.string
});

export const Cache = t.intersection([CacheR, CacheO], "Cache");

export type Cache = t.TypeOf<typeof Cache>;
